import { Fragment, useContext } from "react";
import { Context } from "Context";
import useCheckMediaQuery from "hooks/useCheckMediaQuery";
import Title from "components/shared/Title";
import Accordion from "components/shared/Accordion";
import Separator from "components/shared/Separator";
import SectionItem from "./SectionItem";
import { HEADING_TYPES } from "components/shared/Heading";

const mainClass = "help-section-list";
const Topics = {
	help: "help",
	faq: "faq",
};

const shouldPrintGroupSeparator = (group, i) =>
	group !== Topics.help || (group === Topics.help && i > 0);

const SectionList = ({
	sections,
	useLinkGroup = true,
	useAccordion = true,
	separateTitleSubtitule = false,
	separateMainContentInMobile = false,
}) => {
	const { config, group } = useContext(Context);
	const isMobileView = useCheckMediaQuery(config.mobileMediaQuery);

	return sections?.map((section, i) => {
		return (
			<ul key={section.id}>
				<li className={mainClass}>
					{isMobileView && useAccordion ? (
						<Accordion title={section.name}>
							{section.categories?.map((category, idx) => (
								<li className={`${mainClass}__item`} key={category.id}>
									{group === Topics.help && idx > 0 && <Separator />}
									<SectionItem
										{...category}
										isLinkGroup={useLinkGroup}
										link={
											category.webLinkList?.length
												? category.webLinkList[0]
												: null
										}
									/>
								</li>
							))}
						</Accordion>
					) : (
						<Fragment>
							{shouldPrintGroupSeparator(group, i) && (
								<Separator section={group} />
							)}
							{section.name && (
								<Title
									headingType={HEADING_TYPES.h3}
									title={section.name}
									subTitle={section.description}
									modifier="main"
									name={group}
									showSeparator={separateTitleSubtitule}
								></Title>
							)}
							{separateMainContentInMobile && isMobileView && <Separator />}
							<ul className={`${mainClass}__content`}>
								{section.categories?.map((category, idx) => (
									<li className={`${mainClass}__item${group === Topics.faq ? '--' + group : ''}`} key={category.id}>
										{!useAccordion && isMobileView && idx > 0 && <Separator />}
										<SectionItem
											{...category}
											link={
												category.webLinkList?.length
													? category.webLinkList[0]
													: null
											}
											isLinkGroup={useLinkGroup}
											headingType={HEADING_TYPES.h4}
										/>
									</li>
								))}
							</ul>
						</Fragment>
					)}
				</li>
			</ul>
		);
	});
};

export default SectionList;
